const config = {
    api_endpoint: window.api_endpoint || 'https://api.firstclassumrah.nl/v1/',
    img_bb_endpoint: window.api_endpoint || 'https:/api.imgbb.com/1/upload?key=33bfdbe8c0c73faee78c2b82d2694fc0',
    application_root: ''
}

export {config}